/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import Constants from "../constants";

/**
 * Status badge component
 * Description: This component is used to display the status of a service.
 */
function StatusBadge({ status, fontSize = "small" }) {
  // Status constants
  // 0: Operational
  // 1: Maintenance
  // 2: Degraded Performance
  // 3: Partial Outage
  // 4: Major Outage

  const { title, backgroundColor, IconComponent } = Constants.status[status];

  return (
    <Tooltip title={ title } arrow style={ { cursor: "pointer" } }>
      <IconComponent fontSize={ fontSize } sx={ { color: backgroundColor } } />
    </Tooltip>
  );
}

StatusBadge.propTypes = {
  fontSize: PropTypes.string,
  status: PropTypes.number
};

export default StatusBadge;
